import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { MatButton } from "@angular/material/button";
import { RouterLink } from "@angular/router";
import { LazyImgDirective } from "../lazy-img.directive";
import { ImgFallbackDirective } from "../shared/img-fallback.directive";
@Component({
  selector: "app-home-left-screen",
  templateUrl: "./home-left-screen.component.html",
  styleUrls: ["./home-left-screen.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton, RouterLink, LazyImgDirective, ImgFallbackDirective]
})
export class HomeLeftScreenComponent implements OnInit {
  @Input() exclusive_story: any = {};
  @Input() exclusive_story2: any = {};
  @Input() exclusive_story3: any = {};
  @Input() top_stories: any = [];

  sources: Array<Object>;
  url: any;

  constructor(private meta: Meta, private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle(
      `TheRightDoctors | Insights from the World's Best Medical Minds`
    );
    this.meta.updateTag({
      name: "description",
      content:
        "EXCLUSIVE: COVID 19 Treatment Success Story From SMS Medical College, Jaipur, India" +
        "Pulmonology experts perspective on Coronavirus, Dr.Ravindra Mehta" +
        "People with Diabetes and Hypertension are more susceptible to COVID-19, Dr. V Mohan" +
        "Vitamin C, Hydration, and a healthy diet are key in the fight against coronavirus, Dr.Pradeep Seth" +
        "COVID-19: Panic liberates stress hormones leading to HIGH BP, Dr. HK Chopra" +
        "COVID 19: Understanding the bugs and breaking some of the myths with Dr. Shashank Joshi" +
        "COVID-19 Pandemic: A detailed analysis by leading cardiologists Dr. Ravi Kasliwal and Dr. Hardeep Kaur Grewal" +
        "COVID-19 Treatment Success Story | Dr. Sudhir Bhandari In Conversation With Dr. Anil Pareek" +
        "COVID-19 fatalities may be more than 3 times in Diabetic patients | Dr CM Batra" +
        "COVID 19: Impact on Pregnancy & Nursing Mothers" +
        "The only way to prevent COVID-19 is to flatten the curve of the spread"
    });

    this.meta.updateTag({
      name: "keywords",
      content:
        "EXCLUSIVE: COVID 19 Treatment Success Story From SMS Medical College, Jaipur, India" +
        "COVID-19 Treatment" +
        "Coronavirus" +
        "Coronavirus Pregnancy" +
        "Coronavirus heart diseases" +
        "Coronavirus live updates" +
        "21 days lockdown"
    });

    this.sources = new Array<Object>();
    this.sources.push({
      src:
        "https://storage.googleapis.com/web-assets/RSSDI_2019/Day-1/Day-0-and-1_360.mp4",
      type: "video/mp4"
    });
  }
}
